export const COUPON_DISCOUNT_TYPES = ['percent', 'fixed'];
//# sourceMappingURL=coupon.js.map